module.exports = __webpack_public_path__ + "img/template-goal.956d9dd0.svg";